//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'
import ServiceObjectMapPopupReport from './ServiceObjectMapPopupReport.vue'
import ServiceObjectMapPopupExternalReport from './ServiceObjectMapPopupExternalReport.vue'
import ReportArhiveObject from '../../Report/ReportArhive/ReportArhiveObject.vue'

export default {
  name: 'ServiceObjectMapPopupReports',
  components: {
    ServiceObjectMapPopupReport,
    ServiceObjectMapPopupExternalReport,
    ReportArhiveObject
  },
  props: {
    serviceObjectId: {
      type: Number,
      required: true
    },
    serviceObjectType: {
      type: String,
      default: null
    },
    serviceObjectNumber: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      blackYellowStat: null,

      itemsToShow: [],
      itemsTotal: null,
      itemsLeft: 0,
      itemsNextPageSize: 0,
      itemsPageLoading: false,
      requestArhive: {},
      expandedArhive: false
    }
  },
  watch: {
    serviceObjectId: {
      handler: function (id) {
        if (!this.itemsPageLoading) {
          this.itemsToShow = []
          this.itemsTotal = null
          if (id) {
            this.loadNextPage()
          } else {
            this.itemsLeft = 0
            this.itemsNextPageSize = 0
          }
        }
        this.expandedArhive = false
      },
      immediate: true
    },
    expandedArhive: function (value) {
      if (value) {
        const objectType = this.getArhiveObjectType(this.serviceObjectType)
        this.$set(this.requestArhive, 'type', objectType)
        this.$set(this.requestArhive, 'objectNumber', this.serviceObjectNumber)
        const typeName = this.getArhiveObjectType(this.serviceObjectType, true)
        this.$set(this.requestArhive, 'typeName', typeName)
      } else {
        this.requestArhive = {}
      }
    }
  },
  methods: {
    loadNextPage: async function () {
      if (!this.$d_hasOperation('serviceObjectReportsView')) {
        return
      }
      this.$emit('load')

      this.itemsPageLoading = true
      try {
        const startIndex = this.itemsToShow.length
        const pageSize = 10
        const itemsLoaded = await this.loadItems(startIndex, pageSize)
        this.itemsToShow.push(...itemsLoaded)

        this.itemsLeft = this.itemsTotal - this.itemsToShow.length
        this.itemsNextPageSize = Math.min(pageSize, this.itemsLeft)
      } catch (ignored) {
      } finally {
        this.$nextTick(() => {
          this.itemsPageLoading = false
        })
      }
    },
    loadItems: function (startIndex, pageSize) {
      const urlParams = new URLSearchParams()
      urlParams.append('start', startIndex)
      urlParams.append('limit', pageSize)
      urlParams.append('external', false)

      return axiosGet({
        url: '/service/delta/serviceobject/reportsHistory/' + this.serviceObjectId + '?' + urlParams.toString(),
        onSuccess: (response) => {
          const black = response.data.result.stat.trafficLight_4
          const yellow = response.data.result.stat.trafficLight_2
          this.blackYellowStat = (black || 0) + (yellow || 0)

          this.itemsTotal = response.data.result.total
          return response.data.result.reports
        },
        onFailure: 'Ошибка получения истории отчётов по объекту обслуживания',
        msgTarget: this
      })
    },
    getArhiveObjectType: function (type, text = false) {
      let name = ''
      switch (type) {
        case 'trafficLight':
          name = text ? 'СО' : 'tl'
          break
        case 'trafficLightT7':
          name = text ? 'Т7' : 't7'
          break
        case 'cameraTV':
          name = text ? 'КТО' : 'kto'
          break
        case 'transportDetector':
          name = text ? 'ДТ' : 'detector'
          break
        case 'TOI':
          name = text ? 'ТОИ' : 'table'
          break
        case 'cameraFVF':
          name = text ? 'ФВФ' : 'fvf'
          break
        default :
          break
      }
      return name
    }
  }
}

